import useControls from "components/hooks/useControls";
import { media } from "components/styles/breakpoints";
import { TouchEvent } from "react";
import { useSelector } from "react-redux";
import { getTravelInfo } from "redux/selectors/characterSelectors";
import { getFightStatus } from "redux/selectors/fightSelectors";
import styled from "styled-components";

const ControlsWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh; // fallback
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  user-select: none;

  ${media.desktop`
    display: none;
  `}
`;

const TouchButton = styled.button`
  pointer-events: auto;
  position: absolute;
  height: 100%;
  width: 15%;
  border: none;
  outline: none;
  touch-action: none;
`;

const MoveLeftButton = styled(TouchButton)`
  left: 0;
  background: linear-gradient(
    to right,
    rgba(67, 255, 250, 0.2) 0%,
    rgba(67, 255, 250, 0.1) 40%,
    transparent 100%
  );

  &:active {
    background: linear-gradient(
      to right,
      rgba(67, 255, 250, 0.4) 0%,
      rgba(67, 255, 250, 0.2) 40%,
      transparent 100%
    );
  }
`;

const MoveRightButton = styled(TouchButton)`
  right: 0;
  background: linear-gradient(
    to left,
    rgba(67, 255, 250, 0.2) 0%,
    rgba(67, 255, 250, 0.1) 40%,
    transparent 100%
  );

  &:active {
    background: linear-gradient(
      to left,
      rgba(67, 255, 250, 0.4) 0%,
      rgba(67, 255, 250, 0.2) 40%,
      transparent 100%
    );
  }
`;

const TouchControls = () => {
  const { isTravelMode } = useSelector(getTravelInfo);
  const fightStatus = useSelector(getFightStatus);

  const { onTouchStart, onTouchEnd } = useControls();

  const handleTouchStart = (event: TouchEvent, direction: "left" | "right") => {
    event.preventDefault();
    onTouchStart(direction);
  };

  const handleTouchEnd = (event: TouchEvent, direction: "left" | "right") => {
    event.preventDefault();
    onTouchEnd(direction);
  };

  const handleTouchCancel = (
    event: TouchEvent,
    direction: "left" | "right"
  ) => {
    event.preventDefault();
    handleTouchEnd(event, direction);
  };

  const handleTouchMove = (event: TouchEvent) => {
    // Prevent scrolling while touching controls
    event.preventDefault();
  };

  const isHidden = fightStatus === "fighting" || isTravelMode;
  if (isHidden) {
    return null;
  }

  return (
    <ControlsWrapper>
      <MoveLeftButton
        onTouchStart={(event) => handleTouchStart(event, "left")}
        onTouchEnd={(event) => handleTouchEnd(event, "left")}
        onTouchCancel={(event) => handleTouchCancel(event, "left")}
        onTouchMove={handleTouchMove}
      />
      <MoveRightButton
        onTouchStart={(event) => handleTouchStart(event, "right")}
        onTouchEnd={(event) => handleTouchEnd(event, "right")}
        onTouchCancel={(event) => handleTouchCancel(event, "right")}
        onTouchMove={handleTouchMove}
      />
    </ControlsWrapper>
  );
};

export default TouchControls;
